<template>
	<div class="useradmin">
        <el-card>
            <el-button type="success" @click="add()" size="mini" style="margin-bottom:20px" icon="el-icon-circle-plus-outline">添加客户</el-button>

            <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="400px">
                <el-row>
                    <el-col :span="6"><span>客户</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="name" placeholder="客户名"></el-input>
                    </el-col>
                </el-row>
              
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                    <el-button type="primary" @click="submit()" size="mini">确 定</el-button>
                </span>
            </el-dialog>

            <el-table
                size="mini"
                :data="tableData"
                stripe
                border>
                <el-table-column
                    prop="create_time"
                    label="创建时间">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="客户">
                </el-table-column>
                
                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>

                <el-table-column label="操作" width="200">
                    <template slot-scope="scope" >
                        <el-button type="danger" size="mini" @click="del(scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

        </el-card>

    </div>
</template>

<script>
    import { url } from '../router/api';

	export default{
		data(){
			return{
                name:'',
                title:'',
                dialogVisible:false,
                tableData:[],
            }
        },
      
        mounted() {
            this.getList()
        },
		methods: {
            getList() {
                this.axios.get(url+'xs/kehuList', {
                    params:{
                        id:'',
                    }
                }).then(res=> {
                    if(res.data.code==1) {
                        this.tableData = res.data.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            submit() {
                if(this.name==''){
                    this.$message.error('请输入姓名');
                    return;
                } else {
                    this.axios.get(url+'xs/adminKehu', {
                        params:{
                            name:this.name,
                            operate:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.getList()
                            this.dialogVisible = false
                        }
                    }).catch(err=> {
                        this.dialogVisible = false
                        console.log(err);
                    });
                }
            },

            add() {
                this.dialogVisible = true
                this.name = ''
                this.title = '添加客户'
            },
            
            del(row) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url+'xs/kehuDel', {
                        params:{
                            id:row.id,
                        }
                    }).then(res=> {
                        this.$message.success(res.data.msg);
                        this.getList()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message.error('取消操作');
                });
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .useradmin  {
        .el-row {
            box-sizing: border-box;
            height: 28px;
            line-height: 28px;
            margin-bottom:10px;
        }
        /deep/ .el-dialog__body {
            padding: 10px 20px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
        }
    }
</style>


